// tokens.js
export const tokens = {
  colors: {
    // Shell oscuro base
    bg0: "#0F1724",
    bg1: "#122034",
    bg2: "#172941",

    // Superficies claras
    paper: "#F4F7FA",
    paper2: "#FFFFFF",
    paperTint: "rgba(255,255,255,0.85)",

    // Bordes y separadores en superficies claras
    borderLight: "rgba(22, 39, 63, 0.12)",
    dividerLight: "rgba(22, 39, 63, 0.12)",

    // Texto sobre fondo oscuro
    textOnDark:  "rgba(236, 245, 255, 0.96)",
    mutedOnDark: "rgba(196, 210, 231, 0.78)",

    // Texto dentro de papers claros
    textOnLight: "rgba(24, 40, 63, 0.94)",
    mutedOnLight: "rgba(24, 40, 63, 0.62)",

    // Acentos principales
    primary: "#E6A93B",
    primary2: "#F2C16D",
    accentTeal: "#1D4E63",
    accentTeal2: "#2A637B",

    // Estado
    error: "#E95F78",
    success: "#44C98A",
  },

  radius: {
    xl: 28,
    lg: 22,
    md: 16,
    sm: 12,
    pill: 999,
  },

  shadow: {
    soft: "0 18px 40px rgba(8,14,24,0.42)",
    paperLift: "0 16px 36px rgba(12,22,36,0.24)",
    neumorphLight: `
      10px 10px 24px rgba(0,0,0,0.16),
      -10px -10px 24px rgba(255,255,255,0.70)
    `,

    insetLight: `
      inset 8px 8px 14px rgba(15,28,45,0.08),
      inset -8px -8px 14px rgba(255,255,255,0.85)
    `,
  },
};
